import {withAuth0, useAuth0 } from '@auth0/auth0-react';
import React, { useState, useEffect } from 'react';
import { Text, View} from 'react-native';
import Loader from '../loader/index.js';
import { helpers } from '../../utils/helpers';


function AuthenticationWrapper(WrappedComponent) {

    const Authentication = withAuth0(class Auth extends React.Component {
        constructor(props) {
            super(props);
        }
    
        componentDidMount() {

        }
    
        componentWillUnmount() {
        }

        setAuthToken = async () => {
        try{
            const {isAuthenticated, getAccessTokenSilently, getIdTokenClaims, isLoading} = this.props.auth0
            const accessToken = await getAccessTokenSilently();
            const idToken = await getIdTokenClaims();
            const token = {
                accessToken: accessToken,
                idToken: idToken
            }
            return(token);
    
        }
        catch(err) {
            console.log('auth err: ', err)
        }}

        _webAuth = () => {
            const {isAuthenticated, isLoading, loginWithRedirect, logout} = this.props.auth0

            if(isLoading){
                return (
                    <View style={{ flexDirection: 'row', height: '100%', alignItems: 'center', justifyContent: 'center', position: 'absolute', width: '100%' }}>
                        <Loader title={"We are almost there ..."}/>
                    </ View>
                )
            }

            const auth = {
                isAuthenticated: isAuthenticated,
                fetchToken: isAuthenticated?this.setAuthToken:false,
                login: loginWithRedirect,
                logout: logout,
            }

            const {forwardedRef, ...rest} = this.props;
            return (
                <WrappedComponent ref={forwardedRef} {...rest} auth={auth}/>
            )

        }

        _nativeAuth = () => {
            const {forwardedRef, ...rest} = this.props;
            const auth = {
                isAuthenticated: false,
                fetchToken: null
            }
            return (
                <WrappedComponent ref={forwardedRef} {...rest} auth={auth}/>
            )

        }


        render() {
            if(helpers.isWeb()){
                return this._webAuth()
            }
            return this._nativeAuth()

        }
        
        })

    return React.forwardRef((props, ref) => {
        return <Authentication {...props} forwardedRef={ref} />;
      });
}

export default AuthenticationWrapper;